import { useDictation } from './useDictation'

/**
 * Diktier-Knopf für ein Textfeld (V1-Parität: Sprachdiktat). Erscheint nur, wenn der Browser die
 * Web-Speech-API kann — sonst rendert er nichts (Feature-Detection). `onText` hängt das Erkannte an.
 */
export function DictationButton({ onText, label }: { onText: (text: string) => void; label: string }) {
  const dictation = useDictation(onText)
  if (!dictation.supported) return null
  return (
    <button
      type="button"
      className={dictation.listening ? 'wf-btn wf-btn--ghost wf-mic wf-mic--on' : 'wf-btn wf-btn--ghost wf-mic'}
      aria-pressed={dictation.listening}
      aria-label={label}
      onClick={dictation.toggle}
    >
      {dictation.listening ? 'Hört zu… (Stopp)' : 'Diktieren'}
    </button>
  )
}
